import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { uploadUsersFromExcel } from '../../redux/rtk/features/user/userSlice';

const UserUploadForm = () => {
    const dispatch = useDispatch();
    const [file, setFile] = useState(null);

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleUpload = () => {
        if (file) {
            const formData = new FormData();
            formData.append('file', file);
            dispatch(uploadUsersFromExcel(formData));
        }
    };


    return (
        <div>
            <input type="file" onChange={handleFileChange} />
            <button onClick={handleUpload}>
                Upload Excel
            </button>
        </div>
    );
};

export default UserUploadForm;
